import _ from 'lodash';
import initialstate from '../../initialstate';
import {
	HttpStatusCodes,
	GALinkStatus,
	ExpandValues,
	GAInstructionStatus,
	documentTypes,
	groupInvolvementSources
} from '../../../util/uiconstants';
import {
	GET_ALL_COMPONENTS,
	POST_NEW_COMPONENT,
	SEND_LINK_REQUEST,
	PUT_COMPONENT,
	DELETE_COMPONENT,
	POST_SEND_INSTRUCTIONS,
	CREATE_ENTITY_FORM,
	CLEAN_COMPONENTS_AND_FORMACTIONS
} from '../../../actions/actiontypes';
import normalizeComponents, {mapComponent, normalizeDocument} from './normalizeComponents';

export default function groupComponentsReducer(state = initialstate.groupAudit.components, action) {
	switch (action.type) {
		case GET_ALL_COMPONENTS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const parameters = {
					...state.parameters
				};
				if (action?.response?.totalEntityCount) parameters.totalEntityCount = action?.response?.totalEntityCount;
				if (action?.response?.pages) parameters.pages = action?.response?.pages;

				let unnormalizedComponents = action?.response;
				if (action?.response?.data) unnormalizedComponents = action?.response?.data;

				return {
					data: normalizeComponents(unnormalizedComponents),
					parameters
				};
			}

			return state;
		}
		case POST_NEW_COMPONENT: {
			if (action?.responseObj?.status === HttpStatusCodes.Created) {
				let normalizedData = normalizeComponents([action.response]);
				return {
					...state,
					data: _.orderBy([...state.data, ...normalizedData], ['shortName'], ['asc'])
				};
			}
			return state;
		}
		case PUT_COMPONENT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return {
					...state,
					data: state.data.map((item) => {
						if (item.gaComponentId === action.payload.gaComponentId) return mapComponent(action.response);
						return item;
					})
				};
			}
			return state;
		}
		case DELETE_COMPONENT: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				return {
					...state,
					data: state?.data?.filter((item) => item.gaComponentId !== action.componentId)
				};
			}
			return state;
		}
		case SEND_LINK_REQUEST: {
			if (action?.responseObj?.status === HttpStatusCodes.Created) {
				const componentsToUpdate = action?.GroupComponents?.map((x) => x.GroupComponentId);

				// Nothing to update.
				if (!componentsToUpdate || componentsToUpdate.length === 0) return state;

				const newState = {
					...state,
					data: state.data.map((x) => {
						if (componentsToUpdate.includes(x.gaComponentId)) {
							return {...x, linkRequest: GALinkStatus.Pending};
						}
						return x;
					})
				};

				return newState;
			}
			return state;
		}
		case POST_SEND_INSTRUCTIONS: {
			if (action?.responseObj?.status === HttpStatusCodes.Created) {
				return {
					...state,
					data: state.data.map((item) => {
						if (item.gaComponentId === action.componentId) {
							return {
								...item,
								sentComponentSnapshotId: item.componentSnapshotId,
								sentScopeSnapshotId: item.snapshotId,
								sentStatusId: GAInstructionStatus.Queued
							};
						}
						return item;
					})
				};
			}
			return state;
		}
		case CREATE_ENTITY_FORM: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				if (action.documentTypeId === documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT) {
					const newData = state?.data?.map((item) => {
						const editedComponent = action.response.find((x) => x.entityObjectId === item.gaComponentId);
						if (!!editedComponent) {
							return {
								...item,
								relatedDocuments: [...item.relatedDocuments, normalizeDocument(editedComponent.document)]
							};
						}
						return item;
					});
					return {...state, data: newData};
				}
			}
			return state;
		}
		case CLEAN_COMPONENTS_AND_FORMACTIONS:
			// Renders Group involvement summary table with up-to-date data.
			return initialstate.groupAudit.components;
		default:
			return state;
	}
}
